import React from "react";

const TitleWithDescription = ({ title, description }) => {
    return (
        <>
            <div className="title-with-desc-section">
                <div className="flex items-center justify-between">
                    <h3>{title}</h3>
                </div>
                <p>{description}</p>
            </div>
        </>
    );
};

export default TitleWithDescription;
